module.exports = __webpack_public_path__ + "img/but_finish.3b17a46a.png";